import React from "react"
import Link from "gatsby-link"
import SEO from '../../components/SEO'
import SVGInline from 'react-svg-inline'

import cover from "../../../static/img/servicii/servicii-cenzorat-large.jpg"

class Page extends React.Component {
  render() {
    const pageSEO = {
      title: "Servicii cenzorat",
      description: "Va punem la dispozitie servicii de cenzorat pentru imobilul dvs.",
      path: "/servicii/cenzorat/"
    };
    return (
      <div className="o-page__content">
        <SEO pageSEO={pageSEO} />
        <div className="c-section-gradient">
          <div className="o-container u-pv-20 u-pv-30@tablet u-text-center@tablet">
            <h1 className="c-page__heading">Servicii cenzorat</h1>
          </div>
        </div>

        <div className="o-container u-pv-20 u-pv-30@tablet u-bg-white">
          <div className="o-container o-container--text u-ph-0">

            <img className="u-mb-20" src={cover} alt="servicii cenzorat"/>

            <p>Efectuarea de verificari contabile lunare.</p>


            <div className="u-text-center">
              <Link to="/preturi/" className="c-button u-mt-30">
                Solicita o oferta personalizata
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Page




// WEBPACK FOOTER //
// ./src/pages/servicii/cenzorat.js